import React, { useCallback } from 'react';
import * as Mui from '@mui/material';
import { RadioField } from '@/types/form';
import { RenderFieldProps } from "@/types/form";

const FRadio = ({ field, value, id, onChange }: RenderFieldProps) => {
  const handleRadioChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(id, e.target.value),
    [id, onChange]
  );

  return (
    <Mui.FormControl component="fieldset" fullWidth margin="normal">
      <Mui.FormLabel component="legend">{field.label}</Mui.FormLabel>
      <Mui.RadioGroup
        value={value ?? ''}
        onChange={handleRadioChange}
        sx={{ flexDirection: 'column' }}
      >
        {(field as RadioField).options?.map((option) => (
          <Mui.FormControlLabel
            key={option}
            value={option}
            control={<Mui.Radio />}
            label={option}
          />
        ))}
      </Mui.RadioGroup>
    </Mui.FormControl>
  );
};

export default React.memo(FRadio);